import { render, staticRenderFns } from "./SupportWhatsappButton.vue?vue&type=template&id=84a502a8&"
import script from "./SupportWhatsappButton.vue?vue&type=script&lang=js&"
export * from "./SupportWhatsappButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports